export default __webpack_public_path__ + "static/prompt-segmentation-e42b6d7ccc8b42781f6d115c109589d4.gif";